import React, { useRef, useState } from "react";
import { HighChartRef, SynchroChart } from "@/components/Charts";
import { usePerformanceOptions } from "./hook";
import { Col, Modal, Row } from "antd";
import Highcharts from "highcharts";
import drilldown from "highcharts/modules/drilldown.js";
import { useRootSelector } from "@/infrastructure/hooks";
import { DashSel } from "@/features/dashboard";
import { groupBy } from "lodash";

import StockTable from "./StockTable";

drilldown(Highcharts);

export default () => {
  const chartCollections = useRef<HighChartRef[]>([]);
  const [selectedIndustry, setSelectedIndustry] = useState<string | null>();
  const options = usePerformanceOptions(setSelectedIndustry);
  const stockPerfMap = groupBy(useRootSelector(DashSel.stockPerf), "industry");

  return (
    <Row justify={"center"}>
      <Modal
        width={"65%"}
        title={selectedIndustry ? selectedIndustry.replace("->", " - ") : ""}
        visible={!!selectedIndustry}
        onCancel={() => setSelectedIndustry(null)}
        footer={null}
      >
        {selectedIndustry ? (
          <StockTable
            data={stockPerfMap[selectedIndustry.split("->")[0]].filter(
              e => e.country === selectedIndustry.split("->")[1]
            )}
          />
        ) : (
          <p>No stock found.</p>
        )}
      </Modal>
      {options.map((opt, i) => (
        <Col span={22} key={i}>
          <SynchroChart immutable={true} options={opt} chartCollections={chartCollections.current} />
        </Col>
      ))}
    </Row>
  );
};
